/**
 * IANA timezone from the accommodation offer for calendar-day stay rules (check-in vs “today”
 * at the property). Use this for cart bookability — not the storefront region / browser host TZ.
 */
export function getAccommodationPropertyTimeZone(
  offer: { property?: { timezone?: string } } | undefined,
): string | undefined {
  const tz = offer?.property?.timezone?.trim()
  return tz || undefined
}
